/**
 * BottomTabBar – mobile main navigation (Plan / Recipes / Pantry / Shop).
 * Account is opened from the header (initials or Login), not duplicated here.
 */
export default function BottomTabBar({
  activeTab,
  onTabChange,
  isAuthenticated = false,
  onRequireLogin,
  guestActive = false,
  navigationLocked = false,
  navigationLockReason = 'Start your kitchen or log in to continue.',
  navigationQuiet = false,
}) {
  const lockedClass = navigationLocked
    ? ` is-locked${navigationQuiet ? ' is-quiet' : ''}`
    : ''
  const showLockIcon = navigationLocked && !navigationQuiet
  function handleAuthTabClick(tab) {
    if (navigationLocked) return
    if (isAuthenticated || guestActive) {
      onTabChange(tab)
      return
    }
    if (tab === 'plan') {
      onTabChange('plan')
      return
    }
    if (typeof onRequireLogin === 'function') {
      onRequireLogin()
    }
  }

  return (
    <nav className="bottom-tab-bar mobile-tabs" role="tablist" aria-label="Mobile navigation">
      <button
        className={`tab-button ${activeTab === 'plan' ? 'active' : ''}${lockedClass}`}
        onClick={() => handleAuthTabClick('plan')}
        role="tab"
        aria-selected={activeTab === 'plan'}
        aria-controls="plan-panel"
        aria-label={navigationLocked ? `Plan. ${navigationLockReason}` : 'Plan'}
        aria-disabled={navigationLocked || undefined}
      >
        <span className="tab-icon-row">
          {showLockIcon ? <i className="fas fa-lock tab-lock" aria-hidden="true" /> : null}
          <span className="tab-icon"><i className="fas fa-calendar-week" aria-hidden="true" /></span>
        </span>
        <span className="tab-label">Plan</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'recipes' ? 'active' : ''}${lockedClass}`}
        onClick={() => handleAuthTabClick('recipes')}
        role="tab"
        aria-selected={activeTab === 'recipes'}
        aria-controls="recipes-panel"
        aria-label={navigationLocked ? `Recipes. ${navigationLockReason}` : 'Recipes'}
        aria-disabled={navigationLocked || undefined}
      >
        <span className="tab-icon-row">
          {showLockIcon ? <i className="fas fa-lock tab-lock" aria-hidden="true" /> : null}
          <span className="tab-icon"><i className="fas fa-utensils" aria-hidden="true" /></span>
        </span>
        <span className="tab-label">Recipes</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'pantry' ? 'active' : ''}${lockedClass}`}
        onClick={() => handleAuthTabClick('pantry')}
        role="tab"
        aria-selected={activeTab === 'pantry'}
        aria-controls="pantry-panel"
        aria-label={navigationLocked ? `Pantry. ${navigationLockReason}` : 'Pantry'}
        aria-disabled={navigationLocked || undefined}
      >
        <span className="tab-icon-row">
          {showLockIcon ? <i className="fas fa-lock tab-lock" aria-hidden="true" /> : null}
          <span className="tab-icon"><i className="fas fa-box-open" aria-hidden="true" /></span>
        </span>
        <span className="tab-label">Pantry</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'shop' ? 'active' : ''}${lockedClass}`}
        onClick={() => handleAuthTabClick('shop')}
        role="tab"
        aria-selected={activeTab === 'shop'}
        aria-controls="shop-panel"
        aria-label={navigationLocked ? `Shop. ${navigationLockReason}` : 'Shop'}
        aria-disabled={navigationLocked || undefined}
      >
        <span className="tab-icon-row">
          {showLockIcon ? <i className="fas fa-lock tab-lock" aria-hidden="true" /> : null}
          <span className="tab-icon"><i className="fas fa-shopping-cart" aria-hidden="true" /></span>
        </span>
        <span className="tab-label">Shop</span>
      </button>
    </nav>
  )
}
